import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/job/JobTable/Customer/constants";
import type { CustomerDetails } from "components/job/JobTable/Customer/types";
import useCustomerProps from "components/job/JobTable/Customer/useCustomerProps";

export interface CustomerProps {
  customerDetails: CustomerDetails;
}

const Customer: FunctionComponent<CustomerProps> = ({ customerDetails }) => {
  const { searchWords, name, contact, address } =
    useCustomerProps(customerDetails);

  return (
    <div className="flex flex-col text-12-18">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={name || ""}
        className="text-12-18-em"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={contact || ""}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords || []}
        textToHighlight={address || ""}
      />
    </div>
  );
};

export default Customer;
